import React from 'react';

import {
  Header as FlixHeader,
  HeaderBrand,
  HeaderWidgets,
  HeaderUserWidget,
  HeaderSubNavigation,
  NavItem,
} from '@flixbus/honeycomb-react';

import './Header.scss';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from '../Auth/authConfig';

const Header = () => {
  const { instance, accounts } = useMsal();

  const handleLogin = () => {
    instance.loginPopup(loginRequest);
  };

  const handleLogout = () => {
    instance.logoutPopup();
  };

  return (
    <FlixHeader
      brand={
        <HeaderBrand
          alt='FlixBus'
          href='/'
          src='https://honeycomb.flixbus.com/dist/12.0.2/img/logos/svg/flixbus-white.svg'
        />
      }
      widgets={
        <HeaderWidgets>
          <AuthenticatedTemplate>
            <HeaderUserWidget
              subMenu={
                <HeaderSubNavigation alignment='left' id='header-user-sub-menu'>
                  <NavItem onClick={handleLogout} href='#'>
                    Logout
                  </NavItem>
                </HeaderSubNavigation>
              }
            >
              {accounts[0]?.name}
            </HeaderUserWidget>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <HeaderUserWidget onClick={handleLogin} href='#'>
              Login
            </HeaderUserWidget>
          </UnauthenticatedTemplate>
        </HeaderWidgets>
      }
      fullwidth
    ></FlixHeader>
  );
};

export default Header;
